import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon.png'
import _imports_1 from '../assets/problem.png'


const _withScopeId = n => (_pushScopeId("data-v-70a894cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = { class: "mask_ p-r" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode(" 常见问题")
], -1))
const _hoisted_4 = { class: "cont" }
const _hoisted_5 = { class: "d-f c33 f16 f-w" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_7 = ["innerHTML"]

import top from "./top.vue";
import bottom from "./bottom.vue";
  import { ref, onMounted,onUnmounted,nextTick } from "vue";
  import {list} from "@/axios/index";
  import router from "@/router";
  import { useRoute } from "vue-router";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'details',
  setup(__props) {

const support = (path,index) => {
      router.push({
          path: "./support",
          query: {
          },
      });
  };
  const screenWidth = ref(window.innerWidth);
  const data = ref({
  oldScrollTop: 0,
  });
  const newdata_id= ref("")
  const newdata= ref({})
  const handleResize = () => {
  screenWidth.value = window.innerWidth;
  };
  const route = useRoute();
  const problem = ref([]);
  const lists = async () => {
      const { data }: any = await list({});
      if (data.code == 200) {
          problem.value = data.data
          for (let i = 0; i < data.data.length; i++) {
            if(data.data[i].id == newdata_id.value){
              newdata.value = data.data[i]
              newdata.value.content = newdata.value.content.replace(/<img/g,'<img style="max-width:100%;height:auto" ')
            }              
          }
      }
  };
  onMounted(() => {
    console.log(route.query.data, "asdasdasd");
    if (route.query.data != undefined) {
      newdata_id.value = JSON.parse(route.query.data);
    }
    lists()
    window.addEventListener('resize', handleResize);
    nextTick(() => {
      document.oncontextmenu = new Function("event.returnValue=false");
      document.onselectstart = new Function("event.returnValue=false");
      document.addEventListener("keydown", function (e) {
        if (e.key == "F12") {
          e.preventDefault(); // 如果按下键F12,阻止事件
        }
      });
    })
  });
onUnmounted(() => {
window.removeEventListener('resize', handleResize);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(top),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { class: "d-f j-b f18 cff" }, [
          _hoisted_3,
          _createElementVNode("span", { onClick: support }, "点击查看更多帮助")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(newdata.value.question), 1)
          ]),
          _createElementVNode("div", {
            class: "c33 f16",
            innerHTML: newdata.value.content
          }, null, 8, _hoisted_7)
        ])
      ])
    ]),
    _createVNode(bottom)
  ]))
}
}

})